import { Control, Controller } from "react-hook-form";
import { CartFormValues } from "./types";
import { t } from "i18next";
import React from "react";
import InputBottomSheet from "../../../components/InputBottomSheet";
import { useOrderData } from "../../../providers/orderDataStore";

interface CommentBottomSheetProps {
  control: Control<CartFormValues>;
}

export const CommentBottomSheet = ({ control }: CommentBottomSheetProps) => {
  const { updateOrderData } = useOrderData();

  return (
    <Controller
      name="comment"
      control={control}
      render={({ field: { onChange, value } }) => {
        return (
          <div className="border-b-1 border-gray-200">
            <InputBottomSheet
              rows={6}
              defaultPreviewClassName="w-[95%]"
              title={t("Order comment")}
              inputPlaceholder={t("Enter a comment for the delivery")}
              value={value}
              onFooterSaveClickChange={(value) => {
                onChange(value);
                updateOrderData({
                  customerNote: value,
                });
              }}
            />
          </div>
        );
      }}
    />
  );
};
